import React from 'react';

const AnalyticsPage: React.FC = () => (
  <div className='container-fluid'>
    <div className='card'>
      <div className='card-body d-flex flex-column align-items-center justify-content-center py-20'>
        <i className='bi bi-bar-chart fs-3x text-muted mb-4'></i>
        <div className='fs-4 fw-bold mb-2'>Analytics</div>
        <div className='text-muted'>
          Nothing here yet. Storage tools are in Settings under File Explorer.
        </div>
      </div>
    </div>
  </div>
);

export default AnalyticsPage;
